import { render } from "./orderdetails3.vue?vue&type=template&id=322a64e4&scoped=true"
import script from "./orderdetails3.vue?vue&type=script&lang=js"
export * from "./orderdetails3.vue?vue&type=script&lang=js"

import "./orderdetails3.vue?vue&type=style&index=0&id=322a64e4&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322a64e4"]])

export default __exports__